import { useEffect, useState } from 'react';
import LoadingSpinner from '../components/layout/LoadingSpinner';
import { useSelector } from 'react-redux';
import { RootState } from '../store';

const IframeDisplay = () => {
    const [isLoading, setIsLoading] = useState(true);
    const productType = useSelector((state: RootState) => state.product);
    const url = useSelector((state: RootState) => state.IframeDisplay.url);

    const handleLoad = () => {
        setIsLoading(false);
    };
    useEffect(() => {}, [url]);
    return (
        <>
            <div className="w-full h-full">
                {isLoading && (
                    <div className="absolute inset-0 flex items-center justify-center bg-white z-10">
                        <LoadingSpinner />
                    </div>
                )}
                <iframe
                    className="content-iframe w-full h-full transition-opacity duration-500 ease-in-out"
                    title="Iframe Display"
                    src={url}
                    onLoad={handleLoad}
                    style={{ opacity: isLoading ? 0 : 1 }}
                ></iframe>
            </div>
        </>
    );
};

export default IframeDisplay;
